<template>
  <span>
    <v-btn
      :loading="loadingDelete && simulation._id == currentSimulation"
      :aria-selected="deleteModal"
      @click="openDeleteModal(simulation._id)"
      elevation="0"
      class="ma-1"
      x-small
    >
      <v-icon left x-small>mdi-delete</v-icon>
      Delete
    </v-btn>
    <v-dialog v-model="deleteModal" max-width="400">
      <v-card>
        <v-img src="/img/illustrations/question.svg"></v-img>
        <v-card-title
          ><h3 class="text-center">
            Delete this simulation?
          </h3></v-card-title
        >
        <v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-row dense>
              <v-col>
                <v-btn
                  block
                  x-large
                  @click="deleteModal = false"
                  color="primary"
                >
                  <v-icon left>mdi-close</v-icon> Cancel</v-btn
                >
              </v-col>
              <v-col>
                <v-btn
                  :loading="loadingDelete"
                  color="red darken-4"
                  dark
                  x-large
                  block
                  @click="handleDeleteSimulation"
                >
                  <v-icon left>mdi-delete</v-icon> Confirm</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import api from "@/services/api";
import Swal from "sweetalert2";
import simulator3d from "@/services/simulator3d";
export default {
  name: "DeleteSimulationModalAndButton",
  data: () => ({
    deleteModal: false,
    loadingDelete: false,
    currentSimulation: ""
  }),
  props: {
    simulation: { type: Object, default: Object },
    is3d: { type: Boolean, default: false },
    production: { type: Boolean, default: false },
    productionID: { type: String, default: "" }
  },
  computed: {
    // Simulações 2D e 3D ficam em coleções diferentes (/simulations e /simulations3d)
    service() {
      return this.is3d ? simulator3d : api;
    }
  },
  methods: {
    openDeleteModal: function(simulacao) {
      this.currentSimulation = simulacao;
      this.deleteModal = true;
    },
    redirectToDashboard() {
      this.$router.push("/dashboard").catch(() => {});
    },
    // O backend responde HTTP 200 com { error, message } quando algo falha
    async request(url) {
      const { data } = await this.service.delete(url);
      if (data && data.error) throw new Error(data.message);
      return data;
    },
    deleteSimulation: async function() {
      await this.request(this.currentSimulation);
      this.deleteModal = false;
      this.$emit("deleted");
      this.redirectToDashboard();
    },
    deleteProduction: async function() {
      await this.request(
        `${this.currentSimulation}/productions/${this.productionID}`
      );
      this.deleteModal = false;
      this.$emit("deleted");
    },
    handleDeleteSimulation: async function() {
      if (this.loadingDelete) return;
      this.loadingDelete = true;
      try {
        if (this.production) await this.deleteProduction();
        else await this.deleteSimulation();
        this.currentSimulation = "";
      } catch (err) {
        Swal.fire({ title: "An error occurred", text: err.message });
      } finally {
        this.loadingDelete = false;
      }
    }
  }
};
</script>
